<template>
  <Button 
    :label="label" 
    :icon="icon"
    class="zapi-pill-btn transition-colors transition-duration-150" 
    :class="[
      active ? 'zapi-active' : 'zapi-inactive',
      isSub ? 'zapi-sub' : ''
    ]"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  name: 'ZapiPillButton',
  props: {
    label: { type: String, required: true },
    icon: { type: String, default: '' },
    active: { type: Boolean, default: false },
    isSub: { type: Boolean, default: false }
  },
  emits: ['click']
}
</script>

<style lang="scss" scoped>
.zapi-pill-btn {
  background-color: white !important;
  color: #4b5563 !important;
  border: 1px solid #d1d5db !important;
  border-radius: 999px !important;
  font-size: 1.35rem !important;
  font-weight: 600 !important;
  padding: 0.8rem 1.8rem !important;

  &:focus, &.p-focus {
    box-shadow: none !important;
    outline: none !important;
  }
  
  &:hover:not(.zapi-active) {
    border-color: #e32f3a !important;
    color: #e32f3a !important;
    background-color: #fff9f9 !important;
  }
  
  &:active {
    transform: scale(0.96) !important;
  }

  /* ESTILOS PARA SUBCATEGORÍA */
  &.zapi-sub {
    font-size: 1.15rem !important;
    padding: 0.6rem 1.4rem !important;
    border-color: #E8B84B !important;
    color: #B5760B !important;
    
    &:hover:not(.zapi-active) {
      border-color: #E8A93B !important;
      background-color: #FFF7E6 !important;
      color: #E8A93B !important;
    }
  }
}

.zapi-active {
  background-color: #e32f3a !important;
  border-color: #e32f3a !important;
  color: white !important;
  font-weight: 700 !important;

  &:focus, &.p-focus {
    box-shadow: none !important;
    outline: none !important;
  }

  &.zapi-sub {
    background-color: #E8A93B !important;
    border-color: #E8A93B !important;
    color: white !important;
  }
}
</style>